module.exports = __webpack_public_path__ + "static/Navegando_2-565bf45ee4497c4118c0567a9e8d854a.png";